<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">税率(%)</label>
          </div>
          <div class="weui-cell__bd">
            <select class="weui-select" v-model="value" placeholder="请选择">
              <option>0</option>
              <option>3</option>
              <option>6</option>
              <option>13</option>
            </select>
          </div>
        </div>
      </div>
      <div class="weui-cells__title">可以作为客户、供应商的默认交易税率</div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: "/api/commons/configs",
      value: 13
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadData();
    });
  },
  methods: {
    loadData() {
      var me = this;
      me.$loading({
        url: me.baseUrl + "/getConfigByCode",
        params: {
          code: "defaultTaxRate"
        }
      }).then(function(res) {
        if (res.success) {
          me.value = res.data.data || 0;
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    save() {
      var me = this,
        value = me.value || 0;
      me.$loading({
        url: me.baseUrl + "/update",
        method: "POST",
        jsonData: [
          {
            code: "defaultTaxRate",
            data: value
          }
        ]
      })
        .then(function(res) {
          if (res.success) {
            me.$weui.toast("设置成功", 2000);
            me.$router.back();
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("设置失败", 3000);
        });
    }
  }
};
</script>